import { useEffect } from "react";

/**
 * Slim re-used header block for subpages. Renders an overline,
 * a large heading and an optional subtitle on a dark background
 * — no big background image, no min-h-screen. Scrolls window to top
 * on mount so users always land at the top of a freshly loaded page.
 */
export default function PageHeader({
  overline,
  title,
  subtitle,
  testId,
}) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  return (
    <section
      data-testid={testId || "page-header"}
      className="relative pt-40 pb-20 md:pt-48 md:pb-24 border-b border-white/5 overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at 20% 0%, rgba(212,175,55,0.08) 0%, rgba(0,0,0,0) 60%)",
        }}
      />
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />
      <div className="container-x relative">
        {overline ? (
          <div className="reveal flex items-center gap-4 mb-6">
            <span className="block w-8 h-px bg-[#D4AF37]" />
            <span className="overline text-zinc-400">{overline}</span>
          </div>
        ) : null}
        <h1
          lang="de"
          className="reveal delay-1 font-display text-4xl md:text-5xl lg:text-7xl tracking-tighter font-medium leading-[1.04] max-w-4xl hyphens-auto break-words"
        >
          {title}
        </h1>
        {subtitle ? (
          <p className="reveal delay-2 mt-8 text-zinc-300 text-base md:text-lg leading-relaxed font-light max-w-2xl">
            {subtitle}
          </p>
        ) : null}
      </div>
    </section>
  );
}
